export default "__VITE_ASSET__bGifvRbK__"